import { Button } from "../../ui/button";
import { Label } from "../../ui/label";
import { Textarea } from "../../ui/textarea";
import { Sparkles, Loader2 } from "lucide-react";
import { toast } from "sonner";
import CreditCostTag from "../../CreditCostTag";

export function LessonsLearnedTab({
  lessonsLearned, setLessonsLearned,
  aiDrafts, saving, aiGenerating,
  saveLessonsLearned, generateAiDraft,
}) {
  const applyAiDraft = () => {
    if (aiDrafts?.lessons_learned) {
      setLessonsLearned(aiDrafts.lessons_learned);
      toast.info("AI draft applied. Review and edit before saving.");
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 space-y-6">
      <div className="flex items-center justify-between">
        <h3 className="font-heading font-semibold">Lessons Learned</h3>
        <div className="flex gap-2">
          <Button
            variant="outline" size="sm"
            onClick={() => generateAiDraft("lessons_learned")}
            disabled={!!aiGenerating}
            className="gap-2"
            data-testid="ai-draft-lessons-btn"
          >
            {aiGenerating === "lessons_learned" ? <Loader2 className="w-4 h-4 animate-spin" /> : <Sparkles className="w-4 h-4" />}
            AI Draft
            <CreditCostTag cost={20} />
          </Button>
          {aiDrafts?.lessons_learned && (
            <Button variant="outline" size="sm" onClick={applyAiDraft} data-testid="apply-ai-lessons-btn">
              Apply AI Draft
            </Button>
          )}
        </div>
      </div>

      <div className="space-y-4">
        <div className="space-y-2">
          <Label>What Went Well</Label>
          <Textarea
            placeholder="Describe approaches, methods, and dynamics that contributed to success..."
            value={lessonsLearned.what_went_well || ""}
            onChange={(e) => setLessonsLearned((prev) => ({ ...prev, what_went_well: e.target.value }))}
            rows={5}
            data-testid="lessons-went-well-input"
          />
        </div>

        <div className="space-y-2">
          <Label>What Didn't Go Well</Label>
          <Textarea
            placeholder="Describe challenges, delays, or approaches that didn't produce expected results..."
            value={lessonsLearned.what_didnt || ""}
            onChange={(e) => setLessonsLearned((prev) => ({ ...prev, what_didnt: e.target.value }))}
            rows={5}
            data-testid="lessons-what-didnt-input"
          />
        </div>

        <div className="space-y-2">
          <Label>Recommendations for Future Projects</Label>
          <Textarea
            placeholder="Specific, actionable recommendations based on this project's experience..."
            value={lessonsLearned.recommendations || ""}
            onChange={(e) => setLessonsLearned((prev) => ({ ...prev, recommendations: e.target.value }))}
            rows={5}
            data-testid="lessons-recommendations-input"
          />
        </div>
      </div>

      <Button onClick={saveLessonsLearned} disabled={saving} data-testid="save-lessons-btn">
        {saving ? "Saving..." : "Save Lessons Learned"}
      </Button>
    </div>
  );
}
